import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";

const MemberTable = ({ members, onDelete, onEdit }) => {
  const [sortKey, setSortKey] = useState(null);
  const [sortAsc, setSortAsc] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const handleSort = (key) => {
    if (sortKey === key) {
      setSortAsc(!sortAsc);
    } else {
      setSortKey(key);
      setSortAsc(true);
    }
  };

  const filtered = members.filter((m) => {
    const haystack = (
      m.nume +
      " " +
      m.prenume +
      " " +
      m.email +
      " " +
      m.oras +
      " " +
      m.judet +
      " " +
      m.tara +
      " " +
      m.status_membru
    ).toLowerCase();
    return haystack.includes(searchTerm.toLowerCase());
  });

  const sorted = [...filtered].sort((a, b) => {
    if (!sortKey) return 0;
    const valA = a[sortKey]?.toLowerCase?.() ?? "";
    const valB = b[sortKey]?.toLowerCase?.() ?? "";
    if (valA < valB) return sortAsc ? -1 : 1;
    if (valA > valB) return sortAsc ? 1 : -1;
    return 0;
  });

  return (
    <div className="table-responsive neumorphic p-3 rounded">
      <input
        type="text"
        className="form-control mb-3"
        placeholder="Caută după nume, email, oraș, județ sau statut..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <table className="table table-bordered table-hover align-middle">
        <thead>
          <tr>
            <th onClick={() => handleSort("prenume")} style={{ cursor: "pointer" }}>
              Prenume
            </th>
            <th onClick={() => handleSort("nume")} style={{ cursor: "pointer" }}>
              Nume
            </th>
            <th>CNP</th>
            <th>Serie CI</th>
            <th>Telefon</th>
            <th>Email</th>
            <th>Adresă</th>
            <th>Oraș</th>
            <th>Județ</th>
            <th>Țara</th>
            <th>Cotizație</th>
            <th>Statut</th>
            <th>Acțiuni</th>
          </tr>
        </thead>
        <tbody>
          {sorted.map((m, index) => (
            <tr key={index}>
              <td>{m.prenume}</td>
              <td>{m.nume}</td>
              <td>{m.cnp}</td>
              <td>{m.serie_numar_ci}</td>
              <td>{m.telefon}</td>
              <td>{m.email}</td>
              <td>{m.adresa}</td>
              <td>{m.oras}</td>
              <td>{m.judet}</td>
              <td>{m.tara}</td>
              <td>{m.tip_cotizatie}</td>
              <td>{m.status_membru}</td>
              <td>
                <Dropdown
                  onSelect={(action) => {
                    if (action === "edit") onEdit(m);
                    else if (action === "delete") onDelete(m.id);
                  }}
                >
                  <Dropdown.Toggle variant="secondary" size="sm">
                    Acțiuni
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item eventKey="edit">Editează</Dropdown.Item>
                    <Dropdown.Item eventKey="delete" className="text-danger">
                      Șterge
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MemberTable;
